import { Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { TableInventoriesToExecute } from '../../components/TableInventoriesToExecute/TableInventoriesToExecute'
import { selectClickExecuteInventory } from '../../InventorySelector'
import { actions } from '../../InventoryState'
import * as S from './InventoryExecute.styles'

const InventoryExecute = () => {
  const clickExecute = useSelector(selectClickExecuteInventory)
  const [initialState, setInitialState] = useState(false)

  const dispatch = useDispatch()

  useEffect(() => {
    if (!initialState && clickExecute) {
      dispatch(actions.clearState())
    }
  }, [dispatch, initialState, clickExecute])

  return (
    <S.Wrapper>
      {clickExecute ? <Typography variant='h6' fontWeight='bold'>Executar Inventário</Typography>
        : <Typography variant='h5' fontWeight='bold'>Inventários</Typography>}
      <TableInventoriesToExecute setInitialState={setInitialState} />
    </S.Wrapper>
  )
}

export default InventoryExecute
